module.exports = __webpack_public_path__ + "static/media/mobile.acf76a5e.png";